<div class="copo-datacenter-grid-icon-link datacenter-total-hidden" matRipple [matRippleTrigger]="trigger" [matRippleAnimation]="{ enterDuration: 1000, exitDuration: 500 }">
	<div #trigger>
		<mat-icon class="copo-datacenter-grid-icon-16" [svgIcon]="iconName" (click)="onIconClick()"></mat-icon>
	</div>
</div>